import { render } from "./AddProductDialog.vue?vue&type=template&id=2cb345de&scoped=true"
import script from "./AddProductDialog.vue?vue&type=script&lang=js"
export * from "./AddProductDialog.vue?vue&type=script&lang=js"

import "./AddProductDialog.vue?vue&type=style&index=0&id=2cb345de&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb345de"]])

export default __exports__